import { TypeCoord } from './TypeCoord';
import { TypePers } from './TypePers';
import { TypeAdresse } from './TypeAdresse';

export class TypeAdresseCompleteMorale {

  public coord: TypeCoord;

  public personnePhysique: TypePers;

  public personneMorale: string;

  public adr: TypeAdresse;

  constructor() {
    this.coord = new TypeCoord();
    this.personnePhysique = new TypePers();
    this.personneMorale = '';
    this.adr = new TypeAdresse();

  }
}
